var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": "850",
      "title": `${_vm.openedBill ? '编辑' : '新增'}票据`
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('Form', {
    ref: "formItem",
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-position": "top"
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-left"
  }, [_c('FormItem', {
    attrs: {
      "label": "票据类型",
      "prop": "type"
    }
  }, [_c('RadioGroup', {
    model: {
      value: _vm.formItem.type,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "type", $$v);
      },
      expression: "formItem.type"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "bankAccBill"
    }
  }, [_c('span', [_vm._v("银承")])]), _c('Radio', {
    attrs: {
      "label": "commAccBill"
    }
  }, [_c('span', [_vm._v("商承")])]), _c('Radio', {
    attrs: {
      "label": "check"
    }
  }, [_c('span', [_vm._v("支票")])]), _c('Radio', {
    attrs: {
      "label": "yun"
    }
  }, [_c('span', [_vm._v("云信通")])]), _c('Radio', {
    attrs: {
      "label": "jian"
    }
  }, [_c('span', [_vm._v("建信融通")])]), _c('Radio', {
    attrs: {
      "label": "bankAccBillPaper"
    }
  }, [_c('span', [_vm._v("纸质银承")])]), _c('Radio', {
    attrs: {
      "label": "gold"
    }
  }, [_c('span', [_vm._v("金单")])]), _c('Radio', {
    attrs: {
      "label": "sywx"
    }
  }, [_c('span', [_vm._v("商银微芯")])]), _c('Radio', {
    attrs: {
      "label": "ji"
    }
  }, [_c('span', [_vm._v("集信")])]), _c('Radio', {
    attrs: {
      "label": "zhu"
    }
  }, [_c('span', [_vm._v("筑信")])])], 1)], 1), _c('FormItem', {
    attrs: {
      "label": "客户",
      "prop": "paidByCustomer"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "366px"
    },
    attrs: {
      "filterable": "",
      "disabled": _vm.openedBill ? true : false,
      "remote": "",
      "remote-method": _vm.searchCustomer,
      "loading": _vm.customerLoading,
      "placeholder": "请选择客户"
    },
    model: {
      value: _vm.formItem.paidByCustomer,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "paidByCustomer", $$v);
      },
      expression: "formItem.paidByCustomer"
    }
  }, _vm._l(_vm.customersSimple, function (option) {
    return _c('Option', {
      key: option._id,
      staticStyle: {
        "width": "366px"
      },
      attrs: {
        "value": option._id
      }
    }, [_vm._v(_vm._s(option.name))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "票据所在公司",
      "prop": "company"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.company,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "company", $$v);
      },
      expression: "formItem.company"
    }
  }, _vm._l(_vm.companyList, function (option) {
    return _c('Option', {
      key: option._id,
      attrs: {
        "value": option._id
      }
    }, [_vm._v(_vm._s(option.name))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "金额（元）",
      "prop": "amount"
    }
  }, [_c('InputNumber', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "min": 0
    },
    model: {
      value: _vm.formItem.amount,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "amount", $$v);
      },
      expression: "formItem.amount"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "收款人",
      "prop": "receivedBy"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.receivedBy,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "receivedBy", $$v);
      },
      expression: "formItem.receivedBy"
    }
  }, _vm._l(_vm.simpleUserList, function (option) {
    return _c('Option', {
      key: option._id,
      attrs: {
        "value": option._id
      }
    }, [_vm._v(_vm._s(option.name))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "创建人",
      "prop": "createdBy"
    }
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.openedBill ? _vm.openedBill.createdBy ? _vm.openedBill.createdBy.name : "" : _vm.user.name) + " ")])]), _c('FormItem', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "320px"
    },
    attrs: {
      "type": "textarea",
      "placeholder": "输入备注..."
    },
    model: {
      value: _vm.formItem.remark,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "remark", $$v);
      },
      expression: "formItem.remark"
    }
  })], 1)], 1), _c('div', {
    staticClass: "form-right"
  }, [_c('FormItem', {
    attrs: {
      "label": "汇票编号",
      "prop": "billNo"
    }
  }, [_c('Input', {
    model: {
      value: _vm.formItem.billNo,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "billNo", $$v);
      },
      expression: "formItem.billNo"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "出票公司",
      "prop": "billCompany"
    }
  }, [_c('Input', {
    model: {
      value: _vm.formItem.billCompany,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "billCompany", $$v);
      },
      expression: "formItem.billCompany"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "出票银行",
      "prop": "billBank"
    }
  }, [_c('Input', {
    model: {
      value: _vm.formItem.billBank,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "billBank", $$v);
      },
      expression: "formItem.billBank"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "汇票出票",
      "prop": "billIssuedAt"
    }
  }, [_c('DatePicker', {
    attrs: {
      "type": "date",
      "placeholder": "选择汇票出票日期"
    },
    model: {
      value: _vm.formItem.billIssuedAt,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "billIssuedAt", $$v);
      },
      expression: "formItem.billIssuedAt"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "汇票到期",
      "prop": "billEndedAt"
    }
  }, [_c('DatePicker', {
    attrs: {
      "type": "date",
      "placeholder": "选择汇票到期日期"
    },
    model: {
      value: _vm.formItem.billEndedAt,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "billEndedAt", $$v);
      },
      expression: "formItem.billEndedAt"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "汇票状态",
      "prop": "billStatus"
    }
  }, [_c('RadioGroup', {
    model: {
      value: _vm.formItem.billStatus,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "billStatus", $$v);
      },
      expression: "formItem.billStatus"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "waiting"
    }
  }, [_c('span', [_vm._v("未到期")])]), _c('Radio', {
    attrs: {
      "label": "receive"
    }
  }, [_c('span', [_vm._v("到期收款")])]), _c('Radio', {
    attrs: {
      "label": "overdue"
    }
  }, [_c('span', [_vm._v("逾期无法兑现")])]), _c('Radio', {
    attrs: {
      "label": "paid"
    }
  }, [_c('span', [_vm._v("支付给供应商")])])], 1)], 1), _c('FormItem', {
    attrs: {
      "label": "票据标签",
      "prop": "tags"
    }
  }, [_c('CheckboxGroup', {
    model: {
      value: _vm.formItem.tags,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "tags", $$v);
      },
      expression: "formItem.tags"
    }
  }, [_c('Checkbox', {
    attrs: {
      "label": "heimingdan"
    }
  }, [_c('span', [_vm._v("黑名单")])]), _c('Checkbox', {
    attrs: {
      "label": "ketiexian"
    }
  }, [_c('span', [_vm._v("可贴现")])]), _c('Checkbox', {
    attrs: {
      "label": "6+9"
    }
  }, [_c('span', [_vm._v("6+9")])])], 1)], 1)], 1)]), _c('div', {
    staticClass: "bottom-button"
  }, [_c('FormItem', {
    staticStyle: {
      "margin-left": "16px",
      "margin-bottom": "0"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("保存")])], 1)], 1)])], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }